import {TechnicalApplicationModel} from '../../api/technical-application-model';

export class TechnicalApplicationViewModel {
  id:	string;
  name:	string;
  categoryId:	string;
  minSize:	number;
  maxSize:	number;
  iconURL:	string;
  defaultRatio:	string;
  foilCount: number;
  virginHair:	string;
  calc:	string;
  lastModByID: string;
  lastModDate:	string;
  private wetValue: boolean;
  private activeValue: boolean;

  constructor(item: TechnicalApplicationModel) {
    this.id = item.id;
    this.name = item.name;
    this.categoryId = item.categoryId;
    this.minSize = item.minSize;
    this.maxSize = item.maxSize;
    this.iconURL = item.iconURL;
    this.defaultRatio = item.defaultRatio;
    this.foilCount = item.foilCount;
    this.virginHair = item.virginHair;
    this.calc = item.calc;
    this.lastModByID = item.lastModByID;
    this.lastModDate = item.lastModDate;
    this.wetValue = item.wet === 'Y';
    this.activeValue = item.state === 'A';
  }
}
